module.exports = __webpack_public_path__ + "static/media/daily-xs.56fe78bd.jpg";